import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-teal-400"></i>
              </div>
              <span className="text-xl font-bold text-white">EarnProof</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Echte Apps. Echte Einnahmen. Wir zeigen dir nur geprüfte und bewährte Earning-Tools mit echten Beweisen und ehrlichen Reviews.
            </p>
            <div className="space-y-4">
              <h3 className="text-white font-semibold text-lg">Folge uns</h3>
              <div className="flex space-x-4">
                <a href="https://x.com/EarnProof" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
                <a href="https://t.me/EarnProofSupport" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors">
                  <i className="ri-telegram-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/reviews" className="text-gray-400 hover:text-teal-400 transition-colors">App Reviews</Link></li>
              <li><Link to="/mining" className="text-gray-400 hover:text-teal-400 transition-colors">Mining Tools</Link></li>
              <li><Link to="/taktik" className="text-gray-400 hover:text-teal-400 transition-colors">Meine Taktik</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-teal-400 transition-colors">Blog</Link></li>
              <li><Link to="/realtalk" className="text-gray-400 hover:text-teal-400 transition-colors">RealTalk</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-teal-400 transition-colors">Über uns</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Rechtliches</h3>
            <ul className="space-y-3">
              <li>
                <a href="/contact" className="text-gray-400 hover:text-teal-400 transition-colors">
                  Kontakt
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-teal-400 transition-colors">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="/terms" className="text-gray-400 hover:text-teal-400 transition-colors">
                  AGB
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2025 EarnProof. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
}
